<template>
    <div class="pages selectChannels">
        <el-dialog
            title="公众号模版消息"
            :visible.sync="dialogVisible"
            width="80%"
            :before-close="handleClose">
            <div class="content">
                <div class="left">
               
                <el-form ref="form" :model="form" label-width="120px" size="mini">
                    <el-form-item label="选择模版:" prop="name" :rules="{
                    required: true, message: '请输入计划名称', trigger: 'blur'
                    }">
                        购物成功
                        <el-button type="text" @click="showmo(1)">重新选择</el-button>
                    </el-form-item>
                    <el-form-item label="模版设置:" prop="">
                        <div class="tent">
                            <el-form ref="form" :model="form" label-width="100px" size="mini">
                                <el-form-item label="first:" prop="name">
                                    <el-button type="text" @click="addbl" icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="请输入内容"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="keyword1:" prop="name">
                                    <el-button type="text" @click="addbl"  icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="#用户名称，你好"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="keyword1:" prop="name">
                                    <el-button type="text" @click="addbl"  icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="#用户名称，你好"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="keyword1:" prop="name">
                                    <el-button type="text" @click="addbl"  icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="#用户名称，你好"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="keyword1:" prop="name">
                                    <el-button type="text" icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="#用户名称，你好"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-form-item>
                     <el-form-item label="打开方式:" prop="name">
                        <div class="xz">
                            <el-radio-group v-model="form.radtype">
                                <el-radio label="1">无</el-radio>
                                <el-radio label="2">小程序</el-radio>
                                <el-radio label="3">H5</el-radio>
                            </el-radio-group>
                            <p v-if="form.radtype==2">
                                <span>选择小程序：</span>
                                <el-select v-model="value" placeholder="请选择跳转小程序">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                            <p v-if="form.radtype==2">
                                <span>小程序路径：</span>
                                <el-select v-model="value" placeholder="请选择跳转路径">
                                    <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                            <p v-if="form.radtype==3">
                                <span>跳转链接：</span>
                                <el-select v-model="value" placeholder="请选择跳转链接">
                                    <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                        </div>
                    </el-form-item>
                </el-form>
                </div>
                <div class="border"></div>
                <div class="right">
                    <p class="ner"> <el-button type="text">内容示例</el-button></p>
                    <div class="bgt">
                        <div>
                            <p>购物成功</p>
                            <p>8月21日</p>
                            <p>{first.DATA}</p>
                            <p><span>消费金额</span>{keyword1.DATA}</p>
                            <p><span>消费时间</span>{keyword2.DATA}</p>
                            <p><span>交易商户</span>{keyword2.DATA}</p>
                            <p><span>消费物品</span>{keyword2.DATA}</p>
                            <p>{remark.DATA}</p>
                            <p><span>详情</span> <i class="el-icon-arrow-right"></i></p>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="短信群发"
            :visible.sync="dialogVisible3"
            width="80%"
            :before-close="handleClose">
            <div class="content">
                <div class="left">
                    <el-form ref="form" :model="form" label-width="120px" size="mini">
                        <el-form-item label="短信内容:" prop="name" :rules="{
                        required: true, message: '请输入计划名称'}">
                        <div class="dxg">
                            <p class="titles">
                                <img src="../../../assets/images/newIcon/miban_line_icon.png" alt="">
                                <el-button type="text" @click="showmo(2)">选择模版</el-button>
                            </p>
                            <p>
                                <el-input
                                type="textarea"
                                :rows="6"
                                resize="none"
                                placeholder="#用户名称，你好"
                                v-model="textarea">
                                </el-input>
                            </p>
                        </div>
                            
                        </el-form-item>
                        <el-form-item class="formLes" label="" prop="">
                            <div class="tent tent2">
                                <p class="tit">
                                    <span> 
                                        <img src="../../../assets/images/newIcon/chuda_zhankai_icon.png" alt="">
                                        内容变量
                                        
                                    </span>
                                    <el-button type="text" icon="el-icon-plus" @click="addVar">插入变量</el-button>
                                </p>
                                <ul>
                                    <li v-for="(item,index) in listVar" :key="index">
                                        <div>
                                        <p>变量名称<el-tooltip class="item" effect="dark" content="Right Center 提示文字" placement="right">
                                        <img src="../../../assets/images/newIcon/tishi_icon.png" alt="">
                                        </el-tooltip></p>
                                        <p><el-input
                                        class="iptRdio"
                                        placeholder="输入变量名称"
                                        v-model="item.name"
                                        ></el-input></p>
                                        </div>
                                        <div>
                                            <p>选择变量</p>
                                            <p> <el-select v-model="value" placeholder="请选择">
                                                <el-option
                                                v-for="t in item.options"
                                                :key="t.value"
                                                :label="t.label"
                                                :value="t.value">
                                                </el-option>
                                            </el-select></p>
                                        </div>
                                         <el-button type="text" icon="el-icon-close" @click="delVar(index)"></el-button>
                                    </li>
                                </ul>
                            </div>
                        </el-form-item>
                        <el-form-item label="短信签名:" prop="name" :rules="{
                        required: true, message: '请选择已添加短信签名'}">
                            <p class="mb-15">
                                <el-select v-model="value" placeholder="请选择已添加短信签名">
                                    <el-option
                                    v-for="item in options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                           
                            <p>
                                <el-checkbox v-model="checked"></el-checkbox>
                                我已阅读并同意
                                <el-button type="text"  >《短信服务协议》</el-button>
                            </p>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="border"></div>
                <div class="right right2">
                    <p class="ner"> <el-button type="text">内容示例</el-button></p>
                    <div class="bgt">
                        <div>
                            <!-- <p>购物成功</p>
                            <p>8月21日</p>
                            <p>{first.DATA}</p>
                            <p><span>消费金额</span>{keyword1.DATA}</p>
                            <p><span>消费时间</span>{keyword2.DATA}</p>
                            <p><span>交易商户</span>{keyword2.DATA}</p>
                            <p><span>消费物品</span>{keyword2.DATA}</p>
                            <p>{remark.DATA}</p>
                            <p><span>详情</span> <i class="el-icon-arrow-right"></i></p> -->
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible3 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="push推送"
            :visible.sync="dialogVisible4"
            width="80%"
            :before-close="handleClose">
            <div class="content2 content">
                <div class="left">
                <el-form ref="form" :model="form" label-width="120px" size="mini">
                    <el-form-item label="选择渠道:" prop="name" :rules="{
                    required: true, message: '请输入计划名称', trigger: 'blur'
                    }">
                        <div class="selects">
                            <el-select v-model="value" placeholder="请选择推送方式">
                                <el-option
                                v-for="item in options3"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                            <el-select v-model="value" placeholder="请选择账号">
                                <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                    <el-form-item label="模版设置:" prop="">
                        <div class="tent tent3">
                            <el-form ref="form" :model="form" label-width="100px" size="mini">
                                <el-form-item label="推送标题:" prop="name">
                                    <el-button type="text" @click="addbl" icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="请输入内容"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="推送内容:" prop="name">
                                    <el-button type="text" @click="addbl"  icon="el-icon-plus">插入变量</el-button>
                                    <el-input
                                    type="textarea"
                                    :rows="6"
                                    resize="none"
                                    placeholder="#用户名称，你好"
                                    v-model="textarea">
                                    </el-input>
                                </el-form-item>
                               
                            </el-form>
                        </div>
                    </el-form-item>
                     <el-form-item label="点击推送后:" prop="name">
                        <div class="xz">
                            <el-radio-group v-model="form.radtype">
                                <el-radio label="1">唤醒应用</el-radio>
                                <el-radio label="2">打开指定链接</el-radio>
                                <el-radio label="3">跳转指定页面</el-radio>
                            </el-radio-group>
                            <p v-if="form.radtype==3">
                                <span>页面路径：</span>
                                <el-select v-model="value" placeholder="请选择跳转路径">
                                    <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                            <p v-if="form.radtype==2">
                                <span>跳转链接：</span>
                                <el-select v-model="value" placeholder="请选择跳转链接">
                                    <el-option
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </p>
                        </div>
                    </el-form-item>
                   
                </el-form>
                </div>
                <div class="border"></div>
                <div class="right right3">
                    <p class="ner"> <el-button type="text"></el-button></p>
                    <div class="bgt">
                        <div>
                            <p><img src="../../../assets/images/newIcon/tanchaung_shoujilogo_icon.png" alt=""> GYMOO+</p>
                            <p></p>
                            <p class="s">你好</p>
                            <p class="s">你好</p>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible4 = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible4 = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
        :title="mubType==1 ? '选择微信模版' : '选择模版'"
        :visible.sync="dialogVisible2"
        width="50%"
        :before-close="handleClose">
            <div class="dialogContent">
                <div class="d1" v-if="mubType==1">
                    <span>
                        自动同步微信模板，每个公众号可以同时使用 25 个模板，如需新建或修改，请至微信公众平台操作
                    </span>
                    <i class="el-icon-refresh-right"></i>
                </div>
                <div v-if="mubType==2" class="mb-15"></div>
                <el-table
                v-if="mubType==1"
                :data="tableData"
                 :header-cell-style="cellStyles"
                :cell-style="cellStyle"
                style="width: 100%">
                    <el-table-column
                        prop=""
                        label=""
                        width="60"
                        >
                        <template slot-scope="scope">
                            <span @click="chageS(scope.row)">
                            <el-radio v-model="checkVal" :label="scope.row.id"><span></span></el-radio>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="模版标题"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="number"
                         show-overflow-tooltip
                        label="模版内容"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="xmember"
                        label="一级行业"
                       
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember"
                        label="二级行业"
                        >
                    </el-table-column>
                </el-table>
                <el-table
                 v-if="mubType==2"
                :data="tableData2"
                :header-cell-style="cellStyles"
                :cell-style="cellStyle"
                style="width: 100%">
                    <el-table-column
                        prop=""
                        label=""
                        width="60"
                        >
                        <template slot-scope="scope">
                            <span @click="chageS(scope.row)">
                            <el-radio v-model="checkVal2" :label="scope.row.id"><span></span></el-radio>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        
                        prop="name"
                        label="模版名称"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="number"
                      
                        label="模版CODE"
                        >
                    </el-table-column>
                    <el-table-column
                       show-overflow-tooltip
                        prop="xmember"
                        label="模版内容"
                       
                        >
                    </el-table-column>
                </el-table>
            </div>
            <!-- <div class="dia-footer"> -->
                <span slot="footer" class=" dialog-footer">
                    <el-button @click="dialogVisible2 = false">取 消</el-button>
                    <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
                </span>
            <!-- </div> -->
           
        </el-dialog>
        <!-- <el-dialog
        title="选择微信模版"
        :visible.sync="dialogVisible2"
        width="50%"
        :before-close="handleClose">
            <div class="dialogContent">
                <div class="d1">
                    <span>
                        自动同步微信模板，每个公众号可以同时使用 25 个模板，如需新建或修改，请至微信公众平台操作
                    </span>
                    <i class="el-icon-refresh-right"></i>
                </div>
                <el-table
                :data="tableData"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                :cell-style="{textAlign:'center',fontSize:'12px'}"
                style="width: 100%">
                    <el-table-column
                        prop=""
                        label=""
                        width="60"
                        >
                        <template slot-scope="scope">
                            <span @click="chageS(scope.row)">
                            <el-radio v-model="checkVal" :label="scope.row.id"><span></span></el-radio>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="模版标题"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="number"
                         show-overflow-tooltip
                        label="模版内容"
                        >
                    </el-table-column>
                    <el-table-column
                        prop="xmember"
                        label="一级行业"
                       
                        >
                    </el-table-column>
                    <el-table-column
                        prop="lmember"
                        label="二级行业"
                        >
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dia-footer dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>
<script>
export default {
    data() {
      return {
        checkVal2:'',
        checkVal:'',
        title:"",
        mubType:1,
        tableData: [{
            id:1,
            name: '购物成功',
            number:"first, keyword1, keyword2…first, keyword1, keyword2…",
            xmember:"IT科技",
            lmember:"IT软件与服务"
        },{
            id:2,
            name: '签到成功',
            number:"first, keyword1, keyword2…first, keyword1, keyword2…",
            xmember:"IT科技",
            lmember:"IT软件与服务"
        },{
            id:3,
            name: '签到成功',
            number:"first, keyword1, keyword2…first, keyword1, keyword2…",
            xmember:"IT科技",
            lmember:"IT软件与服务"
        },{
            id:4,
            name: '签到成功',
            number:"first, keyword1, keyword2…first, keyword1, keyword2…",
            xmember:"IT科技",
            lmember:"IT软件与服务"
        },],
        tableData2: [{
            id:1,
            name: '5.20大促',
            number:"SM18294814",
            xmember:"5.20大促0点开启。比双11更劲爆，尿不湿0…5.20大促0点开启。比双11更劲爆，尿不湿0…",
        },{
            id:2,
            name: '5.20大促',
            number:"SM18294814",
            xmember:"5.20大促0点开启。比双11更劲爆，尿不湿0…5.20大促0点开启。比双11更劲爆，尿不湿0…",
        },{
            id:3,
            name: '5.20大促',
            number:"SM18294814",
            xmember:"5.20大促0点开启。比双11更劲爆，尿不湿0…5.20大促0点开启。比双11更劲爆，尿不湿0…",
        },{
            id:4,
            name: '5.20大促',
            number:"SM18294814",
            xmember:"5.20大促0点开启。比双11更劲爆，尿不湿0…5.20大促0点开启。比双11更劲爆，尿不湿0…",
        },],
        listVar:[
            {name:"",options: [{
            value: '选项1',
            label: '小程序1'
            }, {
            value: '选项2',
            label: '小程序2'
            }]},
            {name:"",options: [{
            value: '选项1',
            label: '小程序1'
            }, {
            value: '选项2',
            label: '小程序2'
            }]},
            {name:"",options: [{
            value: '选项1',
            label: '小程序1'
            }, {
            value: '选项2',
            label: '小程序2'
            }]}
        ],
        textarea:"",
        textarea2:"六一活动开始啦，${name}238元罐，益生菌奶粉208元罐，金装奶粉159元罐。3听起送礼品，详情咨询客服31",
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4:false,
        options: [{
          value: '选项1',
          label: '小程序1'
        }, {
          value: '选项2',
          label: '小程序2'
        }],
        options2: [{
          value: '选项1',
          label: 'home/index.html'
        }, {
          value: '选项2',
          label: 'home/index.html'
        }],
        options3: [{
          value: '选项1',
          label: '极光推送'
        }, {
          value: '选项2',
          label: '极光推送2'
        }],
        options4: [{
          value: '选项1',
          label: '186652455'
        }, {
          value: '选项2',
          label: '1231231231'
        }],
        value: '',
        form: {
            radtype:"2",
            name: '',
            region: '',
            date1: '',
            date2: '',
            timevalue:"",
            delivery: false,
            type: [],
            resource: '',
            desc: ''
        }
      }  
    },
    methods:{
        delVar(i){
            this.listVar.splice(i,1)
        },
        addVar(){
            this.listVar.push({name:"",options: [{
            value: '选项1',
            label: '小程序1'
            }, {
            value: '选项2',
            label: '小程序2'
            }]})
        },
        cellStyles({ row, column, rowIndex, columnIndex }) {
            console.log(rowIndex,columnIndex,11111);
            if (columnIndex==1) {
                return `background:#EEEEEE;font-size:12px;textAlign:left`;
            } else {
                return "background:#EEEEEE;textAlign: center;fontSize:12px"
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            console.log(rowIndex,columnIndex,11111);
            if (columnIndex==1) {
                return `font-size:12px;textAlign:left`;
            } else {
                return 'textAlign:center'
            }
        },
        show(type){
            if(type==1){
                this.dialogVisible=true;
            }else if(type==2){
                 this.dialogVisible3=true;
            }else{
                 this.dialogVisible4=true;
            }
        },
        showmo(type){
            this.mubType=type;
            this.dialogVisible2=true;
        },
        addbl(){
            this.textarea='{keywords}'
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
            .then(_ => {
                done();
            })
            .catch(_ => {});
        }
    }
}
</script>
<style lang="less" scoped>
    /deep/.el-date-range-picker{
        width:450px !important;
    }
    .selectChannels{
        .content{
            display: flex;
            padding:30px 15px;
        }
        .content2{
            .selects{
                /deep/ .el-select{
                    margin-right:15px;
                    width:140px;
                }
            }
        }
        .tent{
            overflow-y: scroll;
            height: 380px;
            box-sizing: border-box;
            padding:30px;
           background: rgba(50, 126, 255, 0.06);
        }
        .left{
            width:50%;
            
        }
        .dialog-footer{
            display: block;
        
            .el-button{
                border-radius: 30px;
            }
        }
        /deep/ .el-dialog__footer{
            border-top:1px solid #ededed;
        }
        .border{
            margin:0 30px;
            margin-top:50px;
            margin-bottom:60px;
            width:1px;
            // height:100%;
            background: #E6E6E6;
        }
        .right{
            width:50%;
            .ner{
                margin-top:15px;
                padding-left:30px;
            }
            .bgt{
                padding:15px;
                margin:0 auto;
                width:251px;
                height:500px;
                background:url('../../../assets/images/newIcon/bianjitp.png') no-repeat;
                background-size:100% 100%;
                div{
                    padding:15px;
                    margin-top:50px;
                    border-radius: 8px;
                    background: #fff;
                    p{
                        padding-bottom:4px;
                        font-size:12px;
                        &:first-child{
                            font-size: 11px;
                            font-weight: 500;
                            color: #333333;
                        }
                        &:nth-child(2){
                            font-size: 7px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #999999;
                        }
                        &:nth-child(3){
                            margin-bottom:8px;
                        }
                        &:last-child{
                            margin-top:10px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding-top:10px;
                            border-top:1px solid #ededed;
                        }
                        
                    }
                }
            }
        }
        .right3{
            .bgt{
                background:url('../../../assets/images/newIcon/tanchuang_shouji_bg.png') no-repeat;
                width:300px;
                height:400px;
                background-size:100% 100%;
                div{
                    background:url('../../../assets/images/newIcon/tanchaung_shoujiwhite_bg.png') no-repeat;
                    background-size:100% 100%;
                    padding:6px 15px;
                    margin:0 15px;
                    margin-top: 75px;
                    min-height:170px;
                    .s{
                        margin-bottom:2px !important;
                    }
                    p{
                        margin-bottom:4px;
                        &:first-of-type{
                            margin-top: 6px;
                            margin-bottom:12px;
                            img{
                                width:20px;
                                height:20px;
                                vertical-align: middle;
                            }
                            font-size: 13px;
                            font-weight: 500;
                            color: #333333;
                        }   
                        &:last-of-type{
                            border:0px;
                            padding-top:0;
                            margin-top:0;
                        }
                    }
                }
            }
        }
        .right2{
            .bgt{
                background:url('../../../assets/images/newIcon/duanxin_bg.png') no-repeat;
                background-size:100% 100%;
                div{
                    background:url('../../../assets/images/newIcon/qipao_bg.png') no-repeat;
                    background-size:100% 100%;
                    margin-top: 110px;
                    min-height:100px;
                }
            }
        }
        .xz{
            p{
                span{
                    width:120px;
                }
                display: flex;
                margin-top:15px;
            }
            .el-select{
                width:100%;
            }
        }
        .dxg{
            .titles{
                img{
                    width:16px;
                    height:16px;
                    vertical-align: middle;
                }
            }
            /deep/ .el-textarea__inner{
                background: #F6F6F6;
            }
        }
        .formLes{
            /deep/ .el-form-item__content{
                margin-left:40px  !important;
            }
        }
        /deep/ .el-input,/deep/ .el-select{
            width:100%;
        }
        .tent3{
            height:auto;
            overflow: inherit;
        }
        .tent2{
            overflow: inherit;
            height:auto;
            padding:15px 15px;
            span{
                display: flex;
                align-items: center;
                img{
                    margin-right:6px;
                    width:16px;
                    height:16px;
                    vertical-align: bottom;
                }
            }
            .tit{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            
            ul{
                li{
                    margin-bottom:15px;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                    img{
                        margin-left:6px;
                        width:14px;
                        height: 14px;
                        vertical-align: middle;
                    }
                    div{
                        width:42%;
                        p{
                            &:first-of-type{
                                font-size:12px;
                                margin-bottom:4px;
                            }
                        }
                    }
                    /deep/ .el-input,/deep/ .el-select{
                        width:100%;
                    }
                    /deep/ .el-input__inner{
                        background: #fff;
                    }
                }
            }
        }
        .dialogContent{
            .d1{
                display: flex;
                justify-content: space-between;
                padding:10px 30px;
                margin:15px 0;
                i{
                     color: #258EF7;
                }
                span{
                    font-size: 12px;
                    font-weight: 400;
                    color: #258EF7;
                }
                background: rgba(73, 116, 251, 0.11);
                border-radius: 4px;
            }
            .el-table{
                border-bottom:0px;
            }
           
        }
        //  /deep/ .el-dialog__footer{
        //     border-top:1px !important;
        // }
    }
</style>